/* eslint-disable camelcase */
export interface RequestParams {
  appToken: string;
  appEnvironment: string;
  body?: object;
}

export interface GetSettlementSummariesParams extends RequestParams {
  page: number;
  pageSize: number;
}

export interface GetSettlementStatementParams {
  appEnvironment: string;
  settlementId: string;
}

export interface AccountsState {
  fetchingAccounts: boolean;
  accounts: AccountsResponse[];
  accountsSummary: {
    payins: AccountsSummary[];
    payouts: AccountsSummary[];
  };
  fetchingSettlementSchedule: boolean;
  settlementSchedule: SettlementScheduleResponse;
  fetchingSettlementSummaries: boolean;
  settlementSummaries: SettlementSummariesResponse;
}

export const AccountType = {
  PAYINS: 'PAYINS',
  PAYOUTS: 'PAYOUTS',
};

export const AccountTypeDetails = {
  [AccountType.PAYINS]: {
    label: 'Pay-ins',
    icon: 'ArrowBottomRight',
  },
  [AccountType.PAYOUTS]: {
    label: 'Pay-outs',
    icon: 'ArrowTopRight',
  },
};

export interface AccountsResponse {
  id: string;
  name: string;
  iban: string;
  currency: string;
  type: string;
  balance: number;
}

export interface AccountsError {}

interface AccountsSummary {
  label: string;
  value: string;
}

export interface SettlementScheduleResponse {
  application_id: string;
  settlement_schedule_cron: string;
  settlement_schedule_cron_readable: string;
  created_at: string;
  updated_at: string;
  last_updated_by: string;
}

export interface SettlementScheduleError {}

export const SettlementStatus = {
  CREATED: 'CREATED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const SettlementStatusLabel = {
  [SettlementStatus.CREATED]: 'Pending',
  [SettlementStatus.APPROVED]: 'Completed',
  [SettlementStatus.REJECTED]: 'Rejected',
};

export interface SettlementDestination {
  id: string;
  application_id: string;
  source_name: string;
  source_iban: string;
  iban: string;
  display_name: string;
  currency: string;
  status: string;
  created_timestamp: string;
  updated_timestamp: string;
  updated_by: string;
}

export interface SettlementSummaryContent {
  id: string;
  status: string;
  amount: number;
  currency: string; // Note: not yet available in API
  reference: string;
  destination: SettlementDestination;
  created_timestamp: string;
  updated_timestamp: string;
  updated_by: string;
  payment_count: number;
}

export interface SettlementSummariesResponse {
  content: SettlementSummaryContent[];
  page: {
    number: number;
    size: number;
    total_elements: number;
    total_pages: number;
    sort: Array<string>;
  };
}

export interface SettlementSummariesError {}
